import { ComponentPropsWithoutRef, FC, ReactNode, Ref } from 'react';
import classNames from 'classnames';
import { RadioGroup as RadixRadioGroup } from 'radix-ui';

import RadioGroupItemIndicator from './RadioGroupItemIndicator/RadioGroupItemIndicator';
import styles from './RadioGroupItem.module.css';

type RadioGroupItemPassthroughProps = Omit<
  ComponentPropsWithoutRef<typeof RadixRadioGroup.Item>,
  'className' | 'children'
>;

export type RadioGroupItemLabelPlacement = 'left' | 'right';

export type RadioGroupItemProps = {
  children?: ReactNode;
  /** Спиннер вместо кольца, например пока опция ещё подгружается. */
  loading?: boolean;
  /** Прижать подпись к правому краю на всю ширину контейнера. */
  stretch?: boolean;
  labelPlacement?: RadioGroupItemLabelPlacement;
  className?: string;
  /** Класс для кольца/спиннера. */
  indicatorClassName?: string;
  labelClassName?: string;
  ref?: Ref<HTMLButtonElement>;
} & RadioGroupItemPassthroughProps;

/** Один вариант внутри RadioGroup. */
const RadioGroupItem: FC<RadioGroupItemProps> = ({
  children,
  loading = false,
  stretch = false,
  labelPlacement = 'right',
  className,
  indicatorClassName,
  labelClassName,
  ref,
  ...rest
}) => (
  <RadixRadioGroup.Item
    ref={ref}
    {...rest}
    className={classNames(styles.item, className, {
      [styles.itemStretch]: stretch,
      [styles.itemLabelLeft]: labelPlacement === 'left',
    })}>
    <RadioGroupItemIndicator
      loading={loading}
      className={indicatorClassName}
    />

    {children !== undefined && <span className={classNames(styles.label, labelClassName)}>{children}</span>}
  </RadixRadioGroup.Item>
);

export default RadioGroupItem;
